import { retrieveBulkTimes } from '@/api/common'
import { useQuery } from '@tanstack/vue-query'
import { useProductDetail } from './useProductDetail'
import { createSharedComposable } from '@vueuse/core'
import { useCalcShip } from './useCalcShip'

export const useBulkDiscount = createSharedComposable(() => {
  const { detailInfo } = useProductDetail()
  const { selectedProductCount, shippingConfirmed, bulkPackFlag } = useCalcShip()

  const { data: bulkTimes } = useQuery({
    queryKey: ['/appb/b2b/product/quote/bulkTimes'],
    queryFn: retrieveBulkTimes
  })

  const MOQ = computed(() => detailInfo.value?.minOrderQuantity)

  const minBulkDiscountNumber = computed(() => {
    if (MOQ.value == null || bulkTimes.value == null) return Infinity

    return bulkTimes.value * MOQ.value
  })
  const isBulkDiscount = computed(() => {
    if (shippingConfirmed.value) return bulkPackFlag.value
    return selectedProductCount.value >= minBulkDiscountNumber.value
  })

  return {
    isBulkDiscount
  }
})
